/* UJUS · Favoris (wishlist) — stockage localStorage, pas de compte requis.
   Données stockées par produit : {handle, title, image, price, url}. */
(function () {
  var KEY = 'ujus_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    updateCounts();
  }
  function has(handle) {
    return read().some(function (p) { return p.handle === handle; });
  }
  function toggle(data) {
    var list = read();
    var i = -1;
    for (var k = 0; k < list.length; k++) { if (list[k].handle === data.handle) { i = k; break; } }
    if (i >= 0) { list.splice(i, 1); } else { list.unshift(data); }
    write(list);
    return i < 0; // true = ajouté
  }
  function remove(handle) {
    write(read().filter(function (p) { return p.handle !== handle; }));
  }

  function updateCounts() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.toggleAttribute('hidden', n === 0);
    });
  }

  function initButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(function (btn) {
      if (btn._wlInit) return; btn._wlInit = true;
      var handle = btn.getAttribute('data-handle');
      var saved = has(handle);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var added = toggle({
          handle: handle,
          title: btn.getAttribute('data-title'),
          image: btn.getAttribute('data-image'),
          price: btn.getAttribute('data-price'),
          url: btn.getAttribute('data-url')
        });
        btn.classList.toggle('is-saved', added);
        btn.setAttribute('aria-pressed', added ? 'true' : 'false');
      });
    });
  }

  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var list = read();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.innerHTML = list.map(function (p) {
      var img = p.image ? '<img src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy">' : '';
      return '<article class="ujus-wl-card">' +
        '<button class="ujus-wl-card__remove" type="button" data-wl-remove="' + p.handle + '" aria-label="Retirer des favoris">×</button>' +
        '<a class="ujus-wl-card__media" href="' + p.url + '">' + img + '</a>' +
        '<a class="ujus-wl-card__title" href="' + p.url + '">' + (p.title || '') + '</a>' +
        (p.price ? '<span class="ujus-wl-card__price">' + p.price + '</span>' : '') +
        '<a class="ujus-wl-card__cta" href="' + p.url + '">Voir le produit</a>' +
        '</article>';
    }).join('');
    grid.querySelectorAll('[data-wl-remove]').forEach(function (b) {
      b.addEventListener('click', function () { remove(b.getAttribute('data-wl-remove')); renderGrid(); });
    });
  }

  function init() { initButtons(); updateCounts(); renderGrid(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
